export default "__VITE_ASSET__BxiVgkjK__"